import { AUTOMATED_COMMS_TARGETS } from "features/AutomatedCommunication/constants/AutomatedComms.targets";
import { useMasterSettings } from "../modules/MasterControls/modules/CategoryWiseSettings/utils/useMasterSettings";
import { useSenderManagementSettings } from "../modules/MasterControls/modules/CategoryWiseSettings/utils/useSenderManagementSettings";
import { useEffect } from "react";
import { useFetchEmailDetails } from "features/Integration/modules/EmailSenderIDs/utils/useFetchEmailDetails";
import { getInitialOption } from "features/Integration/modules/EmailSenderIDs/utils/EmailSender.utils";

export const useCommSettingsModal = ({ enabled }) => {
  const { isSuccess: isUserCommSettingsLoaded, data: userCommsSettings } =
    useMasterSettings({
      commTarget: AUTOMATED_COMMS_TARGETS.SENT_TO_USERS,
      enabled,
    });
  const { isSuccess: isCreatorCommSettingsLoaded, data: creatorCommsSettings } =
    useMasterSettings({
      commTarget: AUTOMATED_COMMS_TARGETS.SENT_TO_CREATOR,
      enabled,
    });
  const { isSuccess: isSenderSettingsLoaded, data: senderSettings } =
    useSenderManagementSettings({ enabled });

  const { isLoading: isEmailDetailsLoading } = useFetchEmailDetails();

  const isLoaded =
    isUserCommSettingsLoaded &&
    isCreatorCommSettingsLoaded &&
    isSenderSettingsLoaded;

  useEffect(() => {
    if (isLoaded && !isEmailDetailsLoading) {
      const { name, email } = getInitialOption(senderSettings.email.email);
      senderSettings.email.name = name;
      senderSettings.email.email = email;
    }
  }, [isLoaded, isEmailDetailsLoading]);

  return {
    isLoaded,
    userCommsSettings,
    creatorCommsSettings,
    senderSettings,
  };
};
